import * as React from 'react';

import { cn } from '@/utils';

export interface NavigationIconProps
  extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  text: string;
  active?: boolean;
  disabled?: boolean;
}

const NavigationIcon = React.forwardRef<HTMLDivElement, NavigationIconProps>(
  (
    {
      className,
      icon: Icon,
      text = 'Modules',
      active = false,
      disabled = false,
      ...props
    },
    ref
  ) => {
    // Determine color class based on state
    const getColorClass = () => {
      if (disabled) return 'text-magical-moonlight-d1';
      if (active) return 'text-magical-moonlight-d4';
      return 'text-magical-moonlight-d1';
    };

    const colorClass = getColorClass();

    return (
      <div className="relative h-full flex items-center justify-center">
        <div
          ref={ref}
          className={cn(
            'flex flex-col relative items-center justify-start max-w-16 sm:max-w-21 cursor-pointer',
            disabled && 'opacity-40',
            className
          )}
          {...props}
        >
          <div className={cn('relative shrink-0 sm:size-6 size-5')}>
            <Icon className={cn('size-full', colorClass)} />
          </div>
          <div
            className={cn(
              'font-bold text-center',
              'text-[10px] sm:text-[14px]',
              colorClass
            )}
          >
            {text}
          </div>
        </div>

        {active && !disabled ? (
          <div className="absolute bottom-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="7"
              viewBox="0 0 40 7"
              fill="none"
            >
              <path
                d="M11.458 2.4168C16.9415 0.223414 23.0585 0.223413 28.542 2.41679L40 7H0L11.458 2.4168Z"
                fill="#F15D22"
              />
            </svg>
          </div>
        ) : null}
      </div>
    );
  }
);

NavigationIcon.displayName = 'NavigationIcon';

export { NavigationIcon };
